import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_PATIENT_GOALS } from '_api/queries/goal/useGetPatientGoals';

const DELETE_GOAL = 'delete-exercise-by-id';

export const useDeleteGoal = () => {
  const queryClient = useQueryClient();

  return useApiMutation<{}, { id: number }>(
    ({ id }) => `/goal/${id}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_GOAL],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_PATIENT_GOALS] });
      },
    },
  );
};
